/**
 *
 */
export enum IntegrationApps {
  EDUSIGN = 'edusign',
}
